import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

// initial state
const state = {
  isAdmin: false,
  currentGroup: null,
  allGroups: [],
}

// getters
const getters = {
}

// actions
const actions = {

  async loadIsAdmin ({commit}, {uid}) {

    // Check if the user is an admiin
    if (!uid || uid == null) {
        console.error("Missing UID in loadIsAdmin")
        return
    }

    // Check if we're an admin
    let adminRef = firebase.database().ref('administrators').child(uid)

    try {
        let snap = await adminRef.once("value")
        if (snap.exists()) {
            commit('setIsAdmin', true);
        } else {
            commit('setIsAdmin', false);
        }
    } catch (e) {
        if (e.code == "PERMISSION_DENIED") {
            commit('setIsAdmin', false);
        } else {
            console.error("Caught an exception:"+e.code);
        }
    }
    return true;
  },
}

// mutations
const mutations = {
  setIsAdmin (state, isAdmin) {
    state.isAdmin = isAdmin
  },

  setGroup (state, group) {
    state.group = group
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
